import styled from '@emotion/styled';

import Button from '../../ComponentLibrary/oc-button';
import ContentGroupDropdown from '../../ComponentLibrary/oc-content-group-dropdown';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }
`;

export const CalculatorColumn = styled.div`
  flex: 1;
  min-width: 40%;
  display: flex-column;
  gap: 10px;
`;

export const HeaderArea = styled.div`
  margin-bottom: 25px;
`;

export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${props => (props.noMargin ? '0' : '20px')};
  width: 100%;
  gap: 20px;

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 65%;
  flex: 1;

  @media (max-width: 1200px) {
    max-width: 100%;
  }
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;

  & > div + div,
  a + a {
    margin-left: 8px;

    @media (max-width: 768px) {
      margin-left: ${props => (props.wrapOnMobile ? '0px' : '8px')};
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: ${props => (props.wrapOnMobile ? 'wrap' : 'nowrap')};
    gap: ${props => (props.wrapOnMobile ? '15px' : '0px')};
  }
`;

export const AdditionalItemsDropdown = styled(ContentGroupDropdown)`
  border: 0px;
  border-top: -10px;
  padding-top: 0px;

  & > div:first-child {
    padding-bottom: 5px;
    border-bottom: 1px solid #000000;

    label {
      font-size: 28px;
      line-height: 28px;
      font-weight: 700;
    }
  }

  & > div:last-child {
    padding-top: 5px;
  }
`;

export const AdditionalWarning = styled.p`
  margin-top: 0;
  font-size: 12px;
  line-height: 17px;
`;

export const ResetButton = styled(Button)`
  min-width: fit-content;
`;

export const SheetColumn = styled.div`
  min-width: 55%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  background-color: #e6e6e6;
  padding: 20px 25px;
  height: fit-content;
  gap: 20px;

  @media (max-width: 768px) {
    margin: 0;
    margin-top: 40px;
  }
`;

export const SheetTitle = styled.h2`
  font-size: 28px;
  line-height: 30px;
  font-weight: 600;
`;

export const HeaderRow = styled.tr`
  height: 44px;

  th {
    background-color: #f8f8f8;
    padding: 10px 15px;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    text-transform: initial;
  }

  th:first-of-type {
    text-align: left;
  }
`;

export const BodyRow = styled.tr`
  height: 44px;

  td {
    border-right: 0;
    text-wrap: nowrap;
  }

  td.capitalized {
    text-transform: capitalize;
  }

  td.dark {
    background-color: #f8f8f8;
  }

  &:nth-child(even) {
    background-color: #f8f8f8;
  }
  &:nth-child(odd) {
    background-color: #fff;
  }
`;

export const Footer = styled.div`
  font-size: 12px;

  p:first-child {
    font-weight: 700;
    padding-left: 0px;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 0px;
    padding-left: 5px;
  }

  ul {
    padding-left: 5px;
    margin-top: 0px;
    list-style: none;
  }

  li {
    margin-bottom: 0px;
  }
`;
